module.exports = __webpack_public_path__ + "static/media/cctv6.ff2cc8d5.png";